import integrationActionConstants from '../constants/integrationActionConstants';

const initialState = {
  slackWorkSpaces: [],
  linkedinAccounts: [],
};

const integrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case integrationActionConstants.GET_SLACK_AUTHORIZATION:
      return {
        ...state,
        slackWorkSpaces: [],
      };
    case integrationActionConstants.GET_SLACK_AUTHORIZATION_SUCCESS:
      return {
        ...state,
        slackWorkSpaces: action.payload,
      };
    case integrationActionConstants.GET_SLACK_AUTHORIZATION_ERROR:
      return {
        ...state,
      };
    case integrationActionConstants.UPDATE_SLACK_USER:
      return {
        ...state,
      };
    case integrationActionConstants.UPDATE_SLACK_USER_SUCCESS: {
      const updatedWorkSpaces = [...state.slackWorkSpaces];
      const workSpaceIndex = updatedWorkSpaces.findIndex((work) => work.id === action.payload.id);

      if (workSpaceIndex !== -1) {
        updatedWorkSpaces[workSpaceIndex] = action.payload;
        return {
          ...state,
          slackWorkSpaces: updatedWorkSpaces,
        };
      }
      return {
        ...state,
      };
    }
    case integrationActionConstants.UPDATE_SLACK_USER_ERROR:
      return {
        ...state,
      };
    case integrationActionConstants.GET_LINKEDIN_ACCOUNTS:
      return {
        ...state,
        linkedinAccounts: action.payload,
      };
    case integrationActionConstants.DISCONNECT_LINKEDIN_ACCOUNT:
      return {
        ...state,
        linkedinAccounts: state.linkedinAccounts.filter((i) => i.id !== action.payload),
      };
    default:
      return state;
  }
};

export default integrationReducer;
